import axios from "axios";

// ✅ BACKEND ngrok
const API_URL = process.env.REACT_APP_API_URL;
console.log("🌍 API_URL caricato:", API_URL);


// 🔐 Helper per includere il token in ogni richiesta
const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// LOGIN
export const loginUser = async (email, password) => {
  const formData = new URLSearchParams();
  formData.append("username", email);
  formData.append("password", password);

  const res = await axios.post(`${API_URL}/auth/token`, formData);
  return res.data;
};

// REGISTRAZIONE
export const registerUser = async (email, password) => {
  const res = await axios.post(`${API_URL}/auth/register`, {
    email,
    password,
  });
  return res.data;
};

// CRUD LEAD
export const fetchLeads = async () => {
  const res = await axios.get(`${API_URL}/lead`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const createLead = async (lead) => {
  const res = await axios.post(`${API_URL}/lead`, lead, {
    headers: authHeaders(),
  });
  return res.data;
};

export const updateLead = async (id, lead) => {
  const res = await axios.put(`${API_URL}/lead/${id}`, lead, {
    headers: authHeaders(),
  });
  return res.data;
};

export const deleteLead = async (id) => {
  await axios.delete(`${API_URL}/lead/${id}`, {
    headers: authHeaders(),
  });
};

// CALENDARIO
export const createCalendarEvent = async (eventData) => {
  const res = await axios.post(`${API_URL}/calendar/create-event`, eventData, {
    headers: authHeaders(),
  });
  return res.data;
};

// ✅ TASK CRUD

export const fetchTasks = async () => {
  const res = await axios.get(`${API_URL}/tasks`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const createTask = async (task) => {
  const res = await axios.post(`${API_URL}/tasks`, task, {
    headers: authHeaders(),
  });
  return res.data;
};

export const updateTask = async (taskId, task) => {
  const res = await axios.put(`${API_URL}/tasks/${taskId}/toggle`, null, {
    headers: authHeaders(),
  });
  return res.data;
};

export const deleteTask = async (taskId) => {
  const res = await axios.delete(`${API_URL}/tasks/${taskId}`, {
    headers: authHeaders(),
  });
  return res.data;
};
export const fetchLeadById = async (id) => {
  const res = await axios.get(`${API_URL}/lead/${id}`, { headers: authHeaders() });
  return res.data;
};

export const sendEmail = async (emailData) => {
  const token = localStorage.getItem("token");
  const res = await axios.post(`${API_URL}/email/send`, emailData, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return res.data;
};

export const fetchStatuses = async () => {
  const res = await axios.get(`${API_URL}/statuses`, {
    headers: authHeaders(),
  });
  return res.data;
};

export const createStatus = async (payload) => {
  // payload esempio:
  // { name: "Preventivo", disables_badge: false, sort_order: 50 }
  const res = await axios.post(`${API_URL}/statuses`, payload, {
    headers: authHeaders(),
  });
  return res.data;
};

export const updateStatus = async (statusId, payload) => {
  // payload esempio:
  // { name?: "Nuovo Nome", disables_badge?: true/false, sort_order?: 10 }
  const res = await axios.put(`${API_URL}/statuses/${statusId}`, payload, {
    headers: authHeaders(),
  });
  return res.data;
};

export const deleteStatus = async (statusId) => {
  const res = await axios.delete(`${API_URL}/statuses/${statusId}`, {
    headers: authHeaders(),
  });
  return res.data;
};